import React from "react";
import ContentLoader from "react-content-loader";
import {StyleCard} from "components/Common/StyleCard";
import {StyleDiv} from "components/Common/StyleDiv";
import {isAndroid} from "FirebaseUtils";
import useColorScheme from "hooks/useColorScheme";
import {readToken, ws, wsHex} from "styles/tokens";

interface Props {
  count?: number;
}

function EquipmentsSkeleton({count}: Props) {
  const colorScheme = useColorScheme();
  const loaderBackground = colorScheme === "dark" ? readToken("line") : wsHex.line;
  const loaderForeground = colorScheme === "dark" ? readToken("lineStrong") : wsHex.lineStrong;
  const itemsCount = count ?? (isAndroid ? 12 : 6);
  const cardPadding = isAndroid ? "12px 15px" : "15px";
  const cardHeight = isAndroid ? "auto" : "140px";
  const containerProps = isAndroid
    ? {padding: "0 6px"}
    : {
        padding: "0",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
        gap: "15px"
      };

  return (
    <StyleDiv {...containerProps}>
      {Array.from({length: itemsCount}).map((_, index) => (
        <StyleCard
          key={`equipment-skeleton-${index}`}
          margin={isAndroid ? "0 0 12px 0" : "0"}
          padding={cardPadding}
          height={cardHeight}
          backgroundColor={ws.card}
          borderRadius={ws.radiusLg}
          overflow="hidden"
          boxShadow={ws.shadowSoft}
          style={{border: `1px solid ${ws.line}`}}
        >
          <ContentLoader
            speed={1}
            animate={true}
            rtl={false}
            width={isAndroid ? 520 : 280}
            height={isAndroid ? 70 : 110}
            viewBox={isAndroid ? "0 0 520 70" : "0 0 280 110"}
            backgroundColor={loaderBackground}
            foregroundColor={loaderForeground}
            style={{width: "100%", height: isAndroid ? "70px" : "110px"}}
          >
            {isAndroid ? (
              <>
                <rect x="0" y="10" rx="8" ry="8" width="50" height="50" />
                <rect x="62" y="14" rx="7" ry="7" width="200" height="14" />
                <rect x="62" y="34" rx="6" ry="6" width="160" height="12" />
                <rect x="62" y="52" rx="6" ry="6" width="120" height="12" />
              </>
            ) : (
              <>
                <rect x="0" y="0" rx="8" ry="8" width="50" height="50" />
                <rect x="62" y="6" rx="7" ry="7" width="150" height="14" />
                <rect x="62" y="26" rx="6" ry="6" width="120" height="12" />
                <rect x="0" y="62" rx="6" ry="6" width="96" height="20" />
                <rect x="104" y="62" rx="6" ry="6" width="96" height="20" />
                <rect x="0" y="90" rx="6" ry="6" width="96" height="20" />
                <rect x="104" y="90" rx="6" ry="6" width="96" height="20" />
              </>
            )}
          </ContentLoader>
        </StyleCard>
      ))}
    </StyleDiv>
  );
}

export default EquipmentsSkeleton;
